<div class="d-flex flex-column p-5 border border-1">
  <p class="text-black-50">
    Ce formulaire vous permet de suivre la consommation des services Perval par
    différents utilisateurs. Sélectionnez un mois parmi les 12 derniers pour
    obtenir un état mensuel des consommations. Vous pouvez exporter les données
    sous forme de fichier CSV pour une analyse facile. Ce suivi mensuel aide à
    vérifier l'impact de la délégation de compte des offices sur l'utilisation
    des services.
  </p>

  <div *ngIf="errorMessage" class="my-3 w-50">
    <div class="alert alert-danger" role="alert">
      {{ errorMessage }}
    </div>
  </div>

  <div *ngIf="infoMessage" class="my-3 w-50">
    <div class="alert alert-primary" role="alert">
      {{ infoMessage }}
    </div>
  </div>

  <mat-form-field>
    <mat-label>Sélectionnez une plage de dates</mat-label>
    <mat-date-range-input
      [formGroup]="dateRangeForm"
      [rangePicker]="picker"
      [min]="minStartDate"
      [max]="today"
    >
      <input matStartDate formControlName="start" placeholder="Start date" />
      <input matEndDate formControlName="end" placeholder="End date" />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>

  <div class="mt-3">
    <button
      mat-raised-button
      color="primary"
      [disabled]="isRangeSelected"
      (click)="export()"
    >
      Exporter
    </button>
  </div>
</div>
